import React from 'react';
import { Typography, RegularButton } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { WarningCircleIcon } from '@fronton/icons-react';
import { root, icon, message } from './styles';
import { analyticsUtils } from 'utils';

export const DATA_QA_OUT_OF_STOCK = 'set-out-of-stock';
export const DATA_QA_OUT_OF_STOCK_REDIRECT = 'set-out-of-stock-redirect';

type Props = {
  link: string;
};

export function SetOutOfStock({ link }: Props) {
  const { t } = useTranslation();

  const buttonText = t('product-info.availability.show-similar');

  const sendGaEvent = () => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'komplektyDetail',
      elementName: 'outOfStock',
      elementText: buttonText,
    });
  };

  return (
    <div className={root} data-qa={DATA_QA_OUT_OF_STOCK}>
      <div className={message}>
        <WarningCircleIcon className={icon} type="fill" size="m" color="attention-primary" />
        <Typography size="body_accent" variant="s" color="attention-primary">
          {t('product-info.set.out-of-stock')}
        </Typography>
      </div>
      <RegularButton
        href={link}
        variant="secondary"
        data-qa={DATA_QA_OUT_OF_STOCK_REDIRECT}
        onClick={sendGaEvent}
      >
        {buttonText}
      </RegularButton>
    </div>
  );
}
